module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/summer-rc-9042a7521f8e693cd16343c7088706f5.svg";